import './contact-banner.scss';

import Tooltip from 'bootstrap-italia/src/js/plugins/tooltip';
import { Translations } from '../utils';

const COMPONENT_NAME = 'contact-banner';

const BEM = {
  BLOCK: COMPONENT_NAME,
};

/**
 * version    1.0
 * class      <type> (ContactBanner)
 * classdesc  Component that manage the page header
 */
export class ContactBanner {
  constructor() {
    this.breakpoint = 992;

    this._findUIElements();
    this._bindEvents();
  }

  // private methods

  _findUIElements() {
    this._els = {
      emailText: $(`.${BEM.BLOCK}__contact span`),
    };
  }

  _bindEvents() {
    const self = this;
    self.copyOrEmailTo();
  }

  copyOrEmailTo() {
    // Se il componente non esiste nella pagina, esci senza fare nulla
    if (!this._els.emailText.length) {
      return;
    }

    const email = this._els.emailText.text().trim();
    const $contact = $('.contact-banner__contact');

    if (!$contact.length) {
      return;
    }

    const isMobile = window.innerWidth < this.breakpoint;
    const tooltip = new Tooltip($contact[0], {
      trigger: 'manual',
      offset: isMobile ? '-60, -5' : '-125, -5',
      toggle: 'tooltip',
      placement: 'top',
      title: Translations.getLabel('CONTACT_BANNER_EMAIL_COPIED', {}, 'Email copiata!'),
    });

    const showCopiedTooltip = () => {
      setTimeout(() => {
        $contact[0].focus();
        tooltip.show();

        setTimeout(() => {
          tooltip.hide();
        }, 2500);
      }, 50);
    };

    const copyFallback = (text) => {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();

      try {
        const successful = document.execCommand('copy');
        document.body.removeChild(textarea);
        return successful;
      } catch (err) {
        document.body.removeChild(textarea);
        return false;
      }
    };

    const copyAction = () => {
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        navigator.clipboard.writeText(email)
          .then(() => showCopiedTooltip())
          .catch(() => {
            if (copyFallback(email)) {
              showCopiedTooltip();
            } else {
              window.location.href = `mailto:${email}`;
            }
          });
      } else if (copyFallback(email)) {
        showCopiedTooltip();
      } else {
        window.location.href = `mailto:${email}`;
      }
    };

    // Click con mouse
    $contact.on('click', copyAction);

    // Attivazione da tastiera (Enter o Space)
    $contact.on('keydown', (e) => {
      if (['Enter', ' '].includes(e.key)) {
        e.preventDefault();
        copyAction();
      }
    });
  }
}
